var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRipplingLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 145.3 109.9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 30.5c0-12.1-6.1-22.1-17.5-30.5h26.5c9.3 7.2 15 18.2 15 30.5s-5.7 23.3-15 30.5c8.6 3.6 13.5 12.4 13.5 25v24h-24v-24c0-12-5.7-20.4-16-25 11.4-8.5 17.5-18.4 17.5-30.5m51.9 0c0-12.1-6.1-22.1-17.5-30.5h26.5c9.3 7.2 15 18.2 15 30.5s-5.7 23.3-15 30.5c8.6 3.6 13.5 12.4 13.5 25v24h-24v-24c0-12-5.7-20.4-16-25 11.4-8.5 17.5-18.4 17.5-30.5m52 0c0-12.1-6.1-22.1-17.5-30.5h26.5c9.3 7.2 15 18.2 15 30.5s-5.7 23.3-15 30.5c8.6 3.6 13.5 12.4 13.5 25v24h-24v-24c0-12-5.7-20.4-16-25 11.4-8.5 17.5-18.4 17.5-30.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 215.7,
    x2: -71.9,
    y1: 181.8,
    y2: 181.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.7,
    x2: -71.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.7,
    x2: -71.9,
    y1: 109.8,
    y2: 109.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.7,
    x2: 143.7,
    y1: 181.6,
    y2: -72
  }), /*#__PURE__*/React.createElement("line", {
    y1: -71.2,
    y2: 181.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 85.8,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -24,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: -48,
    y: -48,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: -72,
    y: -72,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 -1.2246e-16 1.2246e-16 -1 -120 339.68)",
    x: -72,
    y: 157.8,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 -1.2246e-16 1.2246e-16 -1 -72 291.68)",
    x: -48,
    y: 133.8,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 -1.2246e-16 1.2246e-16 -1 -24 243.68)",
    x: -24,
    y: 109.8,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 191.7,
    y: 157.8,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.7,
    y: 133.8,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.7,
    y: 109.8,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 -1.2246e-16 1.2246e-16 -1 311.44 -24)",
    x: 143.7,
    y: -24,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 -1.2246e-16 1.2246e-16 -1 359.44 -72)",
    x: 167.7,
    y: -48,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 -1.2246e-16 1.2246e-16 -1 407.44 -120)",
    x: 191.7,
    y: -72,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("rect", {
    x: -72,
    y: -72,
    width: 287.7,
    height: 253.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipplingLogo);
export default __webpack_public_path__ + "static/media/rippling-logo.b5750f86.svg";
export { ForwardRef as ReactComponent };